import { cn } from '@/shared/utils';

import awayShield from '@/assets/team-away.svg';
import homeShield from '@/assets/team-home.svg';
import loserShield from '@/assets/team-loser.svg';

const TEAM_ICONS = {
  home: homeShield,
  away: awayShield,
  loser: loserShield,
};

const getTeamIcon = (team, variant) => {
  if (team?.isWinner === false) {
    return TEAM_ICONS.loser;
  }

  return variant === 'home' ? TEAM_ICONS.home : TEAM_ICONS.away;
};

const TeamColumn = ({ team, align = 'left', iconSide = 'left', variant }) => (
  <div
    className={cn(
      'flex flex-1 items-center gap-2 min-w-0',
      align === 'right' ? 'justify-start' : 'justify-end'
    )}
  >
    <img
      src={getTeamIcon(team, variant)}
      alt=""
      className={cn(
        'size-5 shrink-0',
        iconSide === 'right' ? 'order-2' : 'order-1'
      )}
      loading="lazy"
    />
    <div
      className={cn(
        'flex min-w-0 flex-col',
        align === 'right' && 'text-right',
        iconSide === 'right' ? 'order-1' : 'order-2'
      )}
    >
      <span className="text-sm font-semibold text-white truncate">
        {team?.name}
      </span>
      {team?.city && (
        <span className="text-[11px] text-white/50 truncate">{team.city}</span>
      )}
    </div>
  </div>
);

export default TeamColumn;
